import { api } from './axios'
import type { AlvoPreco, PrecoRow, PrecoResolvido, PrecosEditorData } from '@/types'

export async function listarAlvos() {
  const response = await api.get<AlvoPreco[]>('/parceiros/precos/alvos')
  return response.data
}

export async function getEditorData(targetId: number, uf: string | null) {
  const response = await api.get<PrecosEditorData>(`/parceiros/precos/${targetId}`, {
    params: uf ? { uf } : undefined,
  })
  return response.data
}

export async function resolverPrecos(targetParceiroId: number, rows: PrecoRow[], uf: string | null) {
  const response = await api.post<PrecoResolvido[]>('/parceiros/precos/resolver', {
    targetParceiroId,
    rows,
    uf,
  })
  return response.data
}

export async function salvarPrecos(
  targetId: number,
  rows: PrecoRow[],
  uf: string | null,
  manterCaptadoresIguais?: boolean,
) {
  const response = await api.put<PrecoResolvido[]>(`/parceiros/${targetId}/precos`, {
    rows,
    uf,
    manterCaptadoresIguais,
  })
  return response.data
}
